var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-performance-table',{attrs:{"data":_vm.rows,"custom-headers":_vm.headers,"loading":_vm.loading,"show-diff":_vm.dates.compareWith,"data-grouped-by":_vm.groupBy}})
}
var staticRenderFns = []

export { render, staticRenderFns }